define('views/parts/info-section',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/menu/menu-context',
    // templates
    'text!templates/parts/info-section.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMenuContext,
    // templates
    TInfoSection
) {

    var VInfoSection = Backbone.Epoxy.View.extend({

        // id: "menu",
        template: TInfoSection,
        events: {
            'click .help-toggle': 'toggleHelp',
            'click .info-section-button.bottom': 'onBottomLinkClick',
            'click .info-section-button.top': 'onTopLinkClick',
            'click .options-toggle': 'onMenuOptionToggle',
        },

        regions: {
            help: ".tip-toggle",
            menu: ".menu-options",
            content: ".form-section"
        },

        initialize: function(opt) {
            this.options = _.extend({
                icon: false,
            }, opt);

            this.setButtonDefault();

            this.view = {};
        },

        render: function() {
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, Mustache.getContext(this.options), {
                // partials
                content: this.options.content
            });
            this.$el.empty().append(html);

            this.generateZones();

            return this;
        },

        reset: function() {
            delete this.view.menu;
            delete this.collection;
        },

        toggleHelp: function() {
            this.zone.$help.fadeToggle(300);
        },

        onBottomLinkClick: function(e) {
            var button = this.options.buttonBottom;
            if (button) {
                _.callback(button.context, button.callback, [e]);
            }
        },

        onTopLinkClick: function(e) {
            var button = this.options.buttonTop;
            if (button) {
                _.callback(button.context, button.callback, [e]);
            }
        },

        onMenuOptionToggle: function(e) {
            e.preventDefault();
            if (!this.view.menu) {
                var menu = this.options.menu,
                    context = this.options.context;

                if (!this.collection && menu.init) {
                    this.collection = _.callback(context, menu.init);
                }

                this.view.menu = new VMenuContext(_.extend({
                    collection: this.collection,
                    context: context,
                    onClick: this.onMenuOptionClick.bind(this),
                }, menu));
                this.assign(this.view.menu, this.zone.$menu);
            }
            this.view.menu.toggle();
        },

        onMenuOptionClick: function(e) {
            e.stopPropagation();
        },

        setContent: function(html) {
            this.zone.$content.html(html);
        },

        setButtonDefault: function() {
            var options = this.options;

            if (options.buttonTop) {
                this.options.buttonTop = _.extend({
                    icon: "sl-icon-note",
                    displayIcon: true,
                }, options.buttonTop);
            }

            if (options.buttonBottom) {
                this.options.buttonBottom = _.extend({
                    icon: "sl-icon-note",
                    displayIcon: true,
                }, options.buttonBottom);
            }
        },

        setTitle: function(title) {
            this.options.title = title;
        },

        setHelp: function(help) {
            this.options.help = help;
        },
    });

    return VInfoSection;
});

